module.exports = __webpack_public_path__ + "img/paint_putrescent_pigmentation.ead8056e.png";